import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { COMPANY_LOGO_PATH, COMPANY_NAME } from '../config/brand';
import { AppWindow, Shield, LogOut } from 'lucide-react';
import clsx from 'clsx';

const navigation = [
  { name: 'Applications', href: '/admin/applications', icon: AppWindow },
  { name: 'Audit & Security', href: '/admin/audit', icon: Shield },
];

export function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-background flex">
      <aside className="w-64 border-r border-border bg-background-secondary flex flex-col">
        <div className="p-6 border-b border-border flex items-center gap-2.5">
          <img
            src={COMPANY_LOGO_PATH}
            alt={`${COMPANY_NAME} Logo`}
            width={36}
            height={36}
            className="w-9 h-9 object-contain"
          />
          <div className="min-w-0">
            <h1 className="text-lg font-bold text-foreground leading-tight">Tyaus Auth</h1>
            <p className="text-xs text-foreground-muted mt-0.5 truncate">{user?.email}</p>
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {navigation.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              className={({ isActive }) => clsx(isActive ? 'nav-item-active' : 'nav-item')}
            >
              <item.icon className="w-4 h-4" />
              {item.name}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-border">
          <button onClick={handleLogout} className="nav-item w-full">
            <LogOut className="w-4 h-4" />
            Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
